import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { User } from '../interfaces/user';
import * as Query from '../global-query';
import { MockMenuService } from './mock-menu.service';
import { environment } from '../../environments/environment';

import { AppsyncService } from './appsync.service';
import { Apollo } from 'apollo-angular';

import { LoaderService } from '../pages/loader/loader.service';
import { ItonicsAuthService } from './itonicsAuth.service';

@Injectable()
export class UserService extends MockMenuService {
  private _authToken;
  private loggedInUser;
  private url: string;

  constructor(
    private http: HttpClient,
    public appsync: AppsyncService,
    public apollo: Apollo,
    public itonicsAuthService: ItonicsAuthService,
    public loaderService: LoaderService
  ) {
    super(apollo, appsync, itonicsAuthService, loaderService);

    this.url = 'https://api.datamuse.com/words?ml=';
    // super(appsync);

    /* this.getItems(Query.listMenu).subscribe(menuItems => {
             this._menuItems = menuItems;
         });*/
  }

  registerUser(user: User) {
    // return Observable.create(observer => {

    const query = user.id ? Query.updateUser : Query.addUser;
    return this.addEditUser(user, query);
    /*.subscribe(res => {
                        observer.next(res);
                        observer.complete();
                    }, err => {
                        observer.error(err);
                        observer.complete();
                    });*/

    /*this.addEditUser(user, query).subscribe({
            next: x => console.log('Observer got a next value: ' + x),
            error: err => console.error('Observer got an error: ' + err),
            complete: () => console.log('Observer got a complete notification'),
        });*/
    // });
  }


  getUserList() {
    return this
      .http
      .get(`${environment.backend_url}/api/list/users`);
  }

  userAuthentication(userName, password) {
    return Observable.create((observer) => {
      this.signIn(userName, password, Query.login).subscribe(
        (res) => {
          observer.next({access_token: res});
          observer.error();
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }

  get token() {
    this._authToken = localStorage.getItem('userToken');
    return this._authToken;
  }

  getTokenInfo() {
    /*   return this.http.get(environment.backend_url + '/api/protected', {
               headers: {
                   Authorization: `Bearer ${this.token}`
               }
           });*/
  }

  search_word(term) {
    return Observable.create((observer) => {
      this.searchUserList(term, Query.searchUser).subscribe(
        (userList) => {
          observer.next(userList['data']['searchUser']);
          this.onEnd();
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });

    /*return this.http.get(this.url + term).map(res => {
            return [{id: "1", name: "test", photo: "test"},
                {id: "1", name: "niroj", photo: "test"}
            ];
            /!* return res.json().map(item => {
                 return item.word
             })*!/
        })*/
  }

  loggedDetail() {
    /*  return Observable.create(observer => {

              this.getTokenInfo().subscribe(userInfo => {
                  observer.next(userInfo);
                  observer.complete();
              }, err => {
                  observer.error(err);
              })
          })*/
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts